module.exports = __webpack_public_path__ + "img/login3.1488935f.svg";